<template>
  <div class="home ">

    <HeroSlider />
    <AddressAndInfo />
    <Gallery />
    <Description />
    <Agents />
    <Floorplan />
    <SOI />
    <Footer />

  </div>


</template>

<script>
// @ is an alias to /src
import HeroSlider from '@/components/HeroSlider.vue'
import AddressAndInfo from '@/components/AddressAndInfo.vue'
import Gallery from '@/components/Gallery.vue'
import Description from '@/components/Description.vue'
import Agents from '@/components/Agents.vue'
import Floorplan from '@/components/Floorplan.vue'
import SOI from '@/components/SOI.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    HeroSlider,
    AddressAndInfo,
    Gallery,
    Description,
    Agents,
    Floorplan,
    SOI,
    Footer
  }
}
</script>


<style lang="scss">



</style>